<div class="container">
  <!-- Update Config Form-->
  <form [hidden]="loading" [formGroup]="updateTransitTimeS3Form" (ngSubmit)="submit()"
        class="pure-form pure-form-stacked">

    <!-- Select option for From Country Code Options -->
    <div class="pure-control-group">
      <label for="fromCountryCodeId">From Country Code
        <app-popover [message]="help_messages.from_country_code"></app-popover>
      </label>
      <select id="fromCountryCodeId" class="pure-input-2-3"
              formControlName="fromCountryCode" #fromCountryCode
              (change)="onFromCountryCodeChange(fromCountryCode.value)">
        <option *ngFor="let _fromCountryCode of fromCountryCodeOptions; let i = index"
                [value]="_fromCountryCode">
          {{ _fromCountryCode }}
        </option>
      </select>
    </div>

    <div class="pure-control-group">
      <label for="businessUseCase">Business Use Case
        <app-popover [message]="help_messages.business_unit"></app-popover>
      </label>
      <select name="businessUseCase" id="businessUseCase" class="pure-input-2-3"
              formControlName="businessUseCase" #businessUseCaseRef
              (change)="onBusinessUseCaseChange(businessUseCaseRef.value)">
        <ng-template ngFor let-item [ngForOf]="getItems">
          <optgroup label="{{item.name}}">
            <option *ngFor="let usecase of item.usecases" [value]="usecase.value">
              {{usecase.text}}
            </option>
          </optgroup>
        </ng-template>
      </select>
    </div>

    <!-- Read only text for displaying onboarded component key placeholder-->
    <label for="componentKeyPlaceholderId">Level Of Data
      <app-popover [message]="help_messages.level_of_data"></app-popover>
    </label>
    <input id="componentKeyPlaceholderId" class="pure-input-2-3" type="text"
           formControlName="componentKeyPlaceholder" readonly/>

    <!-- Dynamic entries for Component Key Place holder parts -->
    <form [formGroup]="updateTransitTimeS3Form.get('componentKeyValue')">
      <div *ngFor="let field of currentComponentKeyPlaceholder;let i = index">
        <label for="{{'componentKeyValue'+i}}">{{field}}</label>
        <select type="text" [formControlName]="field" class="pure-input-2-3" id="{{'componentKeyValue'+i}}">
          <option *ngFor="let option of dropDownOptions[field]" [value]="option" [disabled]="passportEnabledShipmethods[option]">
            {{option}}
          </option>
        </select>
      </div>
    </form>

    <!-- Select option for Transit Time Type-->
    <label for="transitTimeTypeId">Select Transit Time Type
      <app-popover [message]="help_messages.transit_time_type"></app-popover>
    </label>
    <select formControlName="transitTimeType" id="transitTimeTypeId" class="pure-input-2-3" #transitTimeTypeRef (change)="onTransitTimeTypeChange(transitTimeTypeRef.value)">
      <option *ngFor=" let _transitTime of transitTimeOptions; let i = index " [value]="_transitTime">
        {{ _transitTime }}
      </option>
    </select>

    <!-- S3 File Path for business uploaded file to business s3 -->
    <div>
      <label for="s3FilePath">S3 File Path
        <app-popover [message]="help_messages.s3_file_path"></app-popover>
      </label>
      <select formControlName="s3FilePath" id="s3FilePath" class="pure-input-2-3">
        <option *ngFor=" let _s3FilePath of s3FilePathOptions; let i = index " [value]="_s3FilePath">
          {{ _s3FilePath }}
        </option>
      </select>
    </div>

    <!-- Submit button-->
    <div>
      <button class="pure-button pure-button-primary button-large" type="submit"
              [disabled]="updateTransitTimeS3Form.invalid">Submit
      </button>
    </div>
  </form>
  <app-loader [loading]="loading" [size]="'small'"></app-loader>
</div>
